import React from 'react'
import {NavLink} from 'react-router-dom'
import {Menu, Sidebar, Header as H} from 'semantic-ui-react'
import './Style.css';
import {observer} from "mobx-react-lite";
import avitoAccountsSettingsStorage from "../../Stores/AvitoAccountsSettingsStorage";
import authStore from "../../Stores/AuthStore";
import permissionsStore from "../../Stores/PermissionsStore";

function Header() {
    return (
        <>
            <Sidebar
                as={Menu}
                icon
                vertical
                visible
                width='thin'
            >
                {authStore.isExternal &&
                    <H style={{marginTop: '15px'}} disabled as={'h4'} textAlign={'center'}>UnitXML</H>
                }
                <Menu.Item
                    as={NavLink}
                    to="/home"
                    icon='home'
                    content='Главная'
                />
                <Menu.Item
                    as={NavLink}
                    to="/unloads"
                    icon='file excel outline'
                    content='XML Файлы'
                />
                <Menu.Item
                    as={NavLink}
                    to="/templates"
                    icon='file alternate'
                    content='Шаблоны'
                />
                {permissionsStore.useTemplatesV2 && <Menu.Item
                    as={NavLink}
                    to="/templatesV2"
                    icon='file alternate'
                    content='Шаблоны V2'
                />}
                <Menu.Item
                    as={NavLink}
                    to="/templateMapping"
                    icon='folder'
                    content='Группы товаров'
                />
                <Menu.Item
                    as={NavLink}
                    to="/stores"
                    icon='boxes'
                    content='Склады'
                />
                <Menu.Item
                    as={NavLink}
                    to="/dictionaries"
                    icon='book'
                    content='Словари'
                    disabled={!permissionsStore.allowDictionaries}
                />
                {authStore.isAdmin &&
                    <Menu.Item
                        as={NavLink}
                        to="/autocatalog"
                        icon='car'
                        content='Автокаталог'
                    />
                }
                {!authStore.isExternal &&
                    <Menu.Item
                        as={NavLink}
                        to="/avito"
                        icon='external alternate'
                        content='Авито'
                        disabled={!permissionsStore.allowAvitoAccounts}
                    />
                }
                {avitoAccountsSettingsStorage.canShowMessenger &&
                    <Menu.Item
                        as={NavLink}
                        to="/messenger"
                        icon='envelope outline'
                        content='Мессенджер'
                        disabled={!permissionsStore.allowAvitoAccounts}
                    />}
                {avitoAccountsSettingsStorage.canShowOrders &&
                    <Menu.Item
                        as={NavLink}
                        to="/orders"
                        icon='shop'
                        content='Заказы Авито'
                        disabled={!permissionsStore.allowAvitoAccounts}
                    />}
                {authStore.isAdminFromUsers && <Menu.Item
                    as={NavLink}
                    to="/settings"
                    icon='settings'
                    content='Настройки'
                />}
                <Menu.Item
                    as={NavLink}
                    to="/help"
                    icon='help'
                    content='Помощь'
                />
                {authStore.isExternal &&
                    <Menu.Item
                        as={NavLink}
                        to="/external/auth"
                        icon='close'
                        content='Выход'
                    />
                }
            </Sidebar>
        </>
    )
}

export default observer(Header);